import { render, staticRenderFns } from "./bigData.vue?vue&type=template&id=4f82841c&"
import script from "./bigData.vue?vue&type=script&lang=js&"
export * from "./bigData.vue?vue&type=script&lang=js&"
import style0 from "./bigData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports